module.exports = __webpack_public_path__ + "static/media/googleplay.3bcf213d.svg";